'use strict';

// ----------------------------------------
// Imports
// ----------------------------------------

import '../_vendors/jquery.spincrement';

// ----------------------------------------
// Public
// ----------------------------------------

let show = true;
let $countBox = $('.spincrement-box');

function spincrementNum () {
	if (!$countBox.length) {
		return false;
	}

	if (!show) {
		return false;
	}

	$('.spincrement').spincrement({
		thousandSeparator: '',
		duration: 5000
	});

	show = false;
}

// ----------------------------------------
// Exports
// ----------------------------------------

export {spincrementNum};



// WEBPACK FOOTER //
// ./src/js/_modules/spincrement.js